import React from 'react';
import { Field } from 'redux-form';

const FormField = ({ source, component: Component, ...rest }) => {
  return <Field component={Component} name={source} {...rest} />;
};

export default FormField;
